import { FC, useEffect } from 'react';

import { IMethod, IMethodResponse, useMethods } from '@entities/method';
import { SelectAsync } from '@shared/components/Form';

interface IProps {
  merchantId?: string;
  currencyId?: string;
  mid_ids?: string;
  selectedMethod?: string;
  name?: string;
  hasFirstSelectedOption?: boolean;
  shouldFilterByCurrency?: boolean;
  onChangeMethod?: (methodId: string) => void;
  onSuccessfulFetch?: (isSuccess: boolean) => void;
}

export const MethodsSelectAsync: FC<IProps> = ({
  merchantId = '',
  currencyId = '',
  mid_ids = '',
  name = 'method_id',
  hasFirstSelectedOption = false,
  selectedMethod,
  onChangeMethod,
  onSuccessfulFetch,
  shouldFilterByCurrency = true,
}) => {
  const { isLoading, isFetching, error, filter, methods, isSuccess } = useMethods({
    merchantId,
    currencyId,
    midIds: mid_ids,
    disableUrlFilter: true,
    shouldFilterByCurrency,
  });

  // successful fetch to parent component
  useEffect(() => {
    if (onSuccessfulFetch && isSuccess !== undefined) {
      onSuccessfulFetch(isSuccess);
    }
  }, [isSuccess, onSuccessfulFetch]);

  const firstSelectedMethodId = hasFirstSelectedOption
    ? { selectedValue: methods?.data[0].id }
    : {};

  return (
    <SelectAsync<IMethod, IMethodResponse>
      name={name}
      data={methods}
      getOptionValue={method => method.id}
      getOptionLabel={method => method.name}
      filter={filter}
      filterKey='code'
      selectedValue={selectedMethod}
      onChange={onChangeMethod}
      {...firstSelectedMethodId}
      isLoading={isLoading || isFetching}
      error={error}
    />
  );
};
